"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _promise = require("babel-runtime/core-js/promise");

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @since 2016-08-06 15:57
 * @author vivaxy
 */

exports.default = function (timeout) {
    return new _promise2.default(function (resolve) {
        setTimeout(resolve, timeout);
    });
};


//////////////////
// WEBPACK FOOTER
// ./~/@dp/varyag-hoc-component/lib/sleep.js
// module id = 263
// module chunks = 0